import { render, staticRenderFns } from "./VerifyPassword.vue?vue&type=template&id=078f0b29"
import script from "./VerifyPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerifyPassword.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VerifyPassword.vue?vue&type=style&index=0&id=078f0b29&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports